export const ExperientialReflection = {
  title: 'Experiential Reflection',
  icon: '/static/templates_icons/ExperientialReflection.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#experiential-reflection">https://parlayideas.com/templates/#experiential-reflection</a>]
    </p>
    <h3>Introduction</h3>
    <p class="pink-selectable">
      [Start by referring back to an experience that students just completed, such as a field trip or
      other class activity. Alternatively, embed a video or podcast to go through and reflect on during
      their own time.]
    </p>
    <h3>Part 1 - Your personal reflection</h3>
    <p>
      In your personal response to the Written RoundTable, please answer all of the following questions:
    </p>
    <p>
      <strong>a) Returning to Experience</strong>
    </p>
    <p>
      - Write down, as best as you can remember, the events that took place in the order that took
      place. Focus on recalling the facts, not your reactions.
    </p>
    <p>
      <strong>b) Attending to Feelings</strong>
    </p>
    <p>
      - Identify one part of the experience that made you react negatively. What was it? Why do you
      think you reacted this way?
    </p>
    <p>
      - Identify one part of the experience that made you react positively. What was it? Why do you
      think you reacted this way?
    </p>
    <p>
      <strong>c) Re-Evaluate the Experience</strong>
    </p>
    <p>
      - What is one thing you learned about <span class="pink-selectable">[subject / topic]</span> that you didn't know before?
      How did your understanding of <span class="pink-selectable">[subject / topic]</span> change?
    </p>
    <p>
      - Were any of your existing beliefs or attitudes challenged or changed? Elaborate.
    </p>
    <h3>Part 2 - Peer Feedback</h3>
    <p>
      After you've submitted your response, comment on at least <span class="pink-selectable">two</span> of your peers' submissions,
      answering the guided feedback questions provided. Try your best to comment on submissions
      that don’t yet have any feedback, and don’t forget to reply to any comments on your own
      submission.
    </p>
    <p class="pink-selectable">
      Recommended Guidance Questions (change in settings above):
      <br><br>
      &nbsp;&nbsp; 1. Were there any similarities in your experiences? What were they? <br>
      &nbsp;&nbsp; 2. What is one part of their reflection that you really appreciated or connected with. Why? <br>
      &nbsp;&nbsp; 3. Is there a different perspective on their recollection of the experience that you can offer? <br>
    </p>
  `,
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/ExperientialReflection.js